export type BosonKind = "photon" | "w" | "gluon" | "higgs" | "quark" | "electron" | "neutrino";

export interface Particle {
  id: number;
  kind: BosonKind;
  born: number;
  ttl: number;
  pos: [number, number, number];
  vel: [number, number, number];
  age?: number;
  data?: Record<string, unknown>;
}

export class ParticlePool {
  private buf: Particle[] = [];
  constructor(private capacity: number) {}

  add(p: Particle) {
    p.age = 0;
    this.buf.push(p);
    while (this.buf.length > this.capacity) this.buf.shift();
  }

  tick(dt: number) {
    for (const p of this.buf) p.age = (p.age ?? 0) + dt;
    this.buf = this.buf.filter((p) => (p.age ?? 0) < p.ttl);
  }

  list(): readonly Particle[] {
    return this.buf;
  }

  size(): number {
    return this.buf.length;
  }

  clear() {
    this.buf = [];
  }
}
